import { render, staticRenderFns } from "./LottoRound.vue?vue&type=template&id=53cde712&"
import script from "./LottoRound.vue?vue&type=script&lang=js&"
export * from "./LottoRound.vue?vue&type=script&lang=js&"
import style0 from "./LottoRound.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports